import { RangeDescriptor } from './RangeDescriptor';
import { FiltriSpedizioni } from '@/store';
import { ComparisonOperator } from '../enums/ComparisonOperator';
import { FinderBase } from './FinderBase';

export class FinderVenduto extends FinderBase
{
    public idStagione?: string;

    public modelloOrigine?: string;
    public zona?: string;

    public constructor(idFornitore: string, pagina?: number) {
        super();
        
        this.idFornitore = idFornitore;
        if(pagina) {
            this.numeroPagina = pagina;
        }        
    }
}